import React from 'react';
import { Box, Skeleton } from '@mui/material';

const StatCardSkeleton = () => (
  <Box className="stat-card" sx={{ p: '14px 16px', borderRadius: '12px', border: '1px solid #ECECEC', display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Skeleton variant="text" width="60%" height={16} />
    <Skeleton variant="text" width="40%" height={30} />
    <Skeleton variant="rounded" width="100%" height={6} />
    <Skeleton variant="text" width="70%" height={14} />
  </Box>
);

export default StatCardSkeleton;
